import styled from 'styled-components';
import { theme, toRem } from 'design';

const Pagination = styled.nav.attrs({ 'aria-label': 'Pagination' })`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  width: auto;
  height: ${toRem(27.5)};
  margin-top: ${toRem(theme.space.lg)};

  @media (min-width: ${theme.breakpoint.small}px) {
    justify-content: flex-end;
    margin-top: 0;
  }
`;

export default Pagination;
